import React from "react";
import "./App.css";
import ProductDashboard from "./components/product/productDashboard";

function App() {
  return <ProductDashboard />;
}

export default App;
